'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatWidgetLocaleContextProvider = exports.ChatWidgetLocaleContextConsumer = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChatWidgetLocaleContext = _react2.default.createContext(undefined);

var ChatWidgetLocaleContextConsumer = exports.ChatWidgetLocaleContextConsumer = ChatWidgetLocaleContext.Consumer;
var ChatWidgetLocaleContextProvider = exports.ChatWidgetLocaleContextProvider = ChatWidgetLocaleContext.Provider;